import { useEffect } from "react";
import { useAppDispatch } from "app/hooks";
import { getEnv } from "app/utils";
import { resetConfirmation } from "slices/confirmation";
import { resetDetails } from "slices/details";
import { resetLanguage } from "slices/language";
import { resetPages } from "slices/pageControl";
import { resetPaxs } from "slices/passenger";
import { resetRetrieve } from "slices/retrieve";

const usePersistBuster = () => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    const persistedVersion = localStorage.getItem("version");
    const currentVersion = getEnv("VERSION", undefined);
    if (
      !persistedVersion ||
      (currentVersion && currentVersion > persistedVersion)
    ) {
      dispatch(resetPages());
      dispatch(resetRetrieve());
      dispatch(resetDetails());
      dispatch(resetConfirmation());
      dispatch(resetPaxs());
      dispatch(resetRetrieve());
      dispatch(resetLanguage());
    }
    localStorage.setItem("version", currentVersion);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
};

export default usePersistBuster;
